import {Component, Input} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-website-info-item',
    templateUrl: './website-info-item.component.html',
    styleUrls: ['./website-info-item.component.css'],
    imports: [TranslateModule]
})
export class WebsiteInfoItemComponent {
  @Input() website
}
